/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

export enum NotificationServices {
  MAGIC_BELL = 'magicBell'
}
export enum NotificationChannels {
  EMAIL = 'email',
  IN_APP = 'in_app',
}

export interface NotificationCategoryPreference {
  email: boolean,
  in_app: boolean,
  group: string,
}

export interface MagicBellPreferences {
  notification_preferences?: {
    categories: {
      [key: string]: NotificationCategoryPreference
    },
    groups: string[]
  }
}
export interface NotificationPreferences {
  userId: string;
  magicBell: MagicBellPreferences;
}

export interface NotificationPreferencesUpdateRequest {
  service: NotificationServices;
  category: string | string[];
  channel: NotificationChannels;
  setting: boolean;
}
